import { create } from 'zustand';

const useUploadStore = create((set, get) => ({
  // State
  droppedImages: [],
  isCreateProductModalOpen: false,
  uploadProgress: {},
  
  // Actions
  setDroppedImages: (images) => set({ droppedImages: images }),
  
  addDroppedImages: (images) => set(state => ({
    droppedImages: [...state.droppedImages, ...images]
  })),
  
  removeDroppedImage: (index) => set(state => ({
    droppedImages: state.droppedImages.filter((_, i) => i !== index)
  })),
  
  clearDroppedImages: () => set({ droppedImages: [] }),
  
  openCreateProductModal: () => set({ isCreateProductModalOpen: true }),
  
  closeCreateProductModal: () => set({ 
    isCreateProductModalOpen: false,
    droppedImages: [] // Clear images when closing
  }),
  
  setUploadProgress: (imageId, progress) => set(state => ({
    uploadProgress: {
      ...state.uploadProgress,
      [imageId]: progress
    }
  })),
  
  clearUploadProgress: () => set({ uploadProgress: {} }),
  
  // Computed values
  hasDroppedImages: () => get().droppedImages.length > 0,
}));

export default useUploadStore;